<div class="tenant-mapping-container mb-3">
  <div class="mapping-header">
    <h2>Tenant Mappings</h2>
    <button kendoButton
      look="clear"
      icon="close"
      (click)="closeMapping()"
      title="Close"></button>
  </div>

  <!-- Warning message if integration not configured -->
  @if (showConfigurationWarning) {
    <div class="alert alert-warning mb-3">
      <i class="k-icon k-i-warning"></i>
      <span>Please save the ConnectWise connection first. Tenant mappings can only be configured after the integration has been successfully saved.</span>
    </div>
  }

  <!-- Add New Mapping Button -->
  <div class="mb-3">
    <button
      kendoButton
      [svgIcon]="plusIcon"
      themeColor="primary"
      (click)="openAddDialog()"
      [disabled]="showConfigurationWarning">
      Add New Mapping
    </button>
  </div>

  <!-- Datatable -->
  @if (datatableUrl()) {
    <app-datatable
      #datatable
      [data-href]="datatableUrl()"
      [columns]="datatableColumns()"
      [initialFilters]="datatableFilters"
      [useOData]="true"
      (click)="handleDatatableClick($event)">
    </app-datatable>
  }
</div>

<!-- Add/Edit Dialog -->
@if (isDialogOpen()) {
  <kendo-dialog
    title="{{ dialogMode === 'add' ? 'Add Tenant Mapping' : 'Edit Tenant Mapping' }}"
    (close)="closeDialog()"
    [minWidth]="600"
    [width]="700">
    <div class="dialog-content" [formGroup]="formGroup">
      <!-- Organization Dropdown -->
      <div class="form-group mb-3">
        <label class="form-label required">Organization</label>
        <cyflare-autocomplete
          [baseUrl]="'v1/organization/administrative/organizationautocomplete/'"
          [textField]="'display_text'"
          [valueField]="'id'"
          [placeholder]="'Search organization...'"
          [showDropdown]="true"
          [completeOnFocus]="false"
          [cacheTtlMs]="2000000"
          [pageSize]="100"
          [lazyScroll]="true"
          [extraQueryParams]="'parent_id=' + organizationId()"
          [defaultItem]="savedOrgItem()"
          [selectedIds]="formGroup.get('organization_id')!.value?.toString() || ''"
          (itemSelected)="onOrgDropdownChanged($event)"
        ></cyflare-autocomplete>
      </div>

      <!-- Company Dropdown -->
      <div class="form-group mb-3">
        <kendo-label
          text="Select Company"
          [optional]="false"
        ></kendo-label>

        <cyflare-autocomplete
          [baseUrl]="'v1/ticketintegration/administrative/organizations/{orgId}/connectwise_companies/'"
          [organizationId]="organizationId()"
          [placeholder]="'Search a company...'"
          [showClear]="true"
          [showDropdown]="true"
          [textField]="'display_text'"
          [cacheTtlMs]="60000"
          [defaultItem]="savedCompanyItem()"
          (itemSelected)="onCompanySelected($event)"
          (itemCleared)="onCompanyCleared()"
        ></cyflare-autocomplete>
      </div>

      <!-- Agreement Dropdown -->
      <div class="form-group mb-3">
        <kendo-label
          text="Select Agreement"
          [optional]="true"
        ></kendo-label>

        <cyflare-autocomplete
          [baseUrl]="agreementBaseUrl()"
          [organizationId]="organizationId()"
          [placeholder]="selectedCompanyId() ? 'Select an agreement...' : 'Select a company first'"
          [showClear]="true"
          [showDropdown]="true"
          [textField]="'display_text'"
          [completeOnFocus]="true"
          [fetchOnInit]="true"
          [cacheTtlMs]="60000"
          [disabled]="!selectedCompanyId()"
          [defaultItem]="savedAgreementItem()"
          (itemSelected)="onAgreementSelected($event)"
          (itemCleared)="onAgreementCleared()"
        ></cyflare-autocomplete>
      </div>
    </div>

    <kendo-dialog-actions>
      <button kendoButton (click)="closeDialog()">Close</button>
      <button kendoButton
        themeColor="primary"
        (click)="saveMapping()"
        [disabled]="!formGroup.valid">
        Save
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}

<!-- Delete Confirmation Dialog -->
@if (isDeleteDialogOpen()) {
  <kendo-dialog
    title="Confirm Delete"
    (close)="closeDeleteDialog()"
    [minWidth]="400"
    [width]="500">
    <div class="dialog-content">
      <p>Are you sure you want to delete this tenant mapping?</p>
      @if (mappingToDelete) {
        <div class="mapping-details">
          <strong>Organization:</strong> {{ mappingToDelete.organization_name }}<br>
          <strong>Company:</strong> {{ mappingToDelete.company_name }}<br>
          <strong>Agreement:</strong> {{ mappingToDelete.agreement_name }}
        </div>
      }
    </div>

    <kendo-dialog-actions>
      <button kendoButton (click)="closeDeleteDialog()">Cancel</button>
      <button kendoButton
        themeColor="error"
        (click)="confirmDelete()">
        Delete
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
